// Lixeira de veículos (pedido 2026-09-11, tela Veículos > ícone de lixeira
// ao lado de Importar/Exportar) — GPS Drive Backend próprio. "Excluir
// dispositivo" (aba Excluir, Editar Veículo) passa a chamar moveToTrash em
// vez de DELETE direto no Traccar: o backend tira o retrato completo
// (device Traccar + vehicle_metadata) ANTES de excluir de verdade, pra dar
// pra restaurar depois. Ver vehicle-trash.service.ts no backend.
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export interface DeletedVehicleSummary {
  id: string;
  traccarDeviceId: number;
  name: string;
  uniqueId: string;
  plate: string | null;
  brand: string | null;
  model: string | null;
  simNumber: string | null;
  deletedAt: string;
}

export const gpsDriveVehicleTrashService = {
  list: () => gpsDriveGet<DeletedVehicleSummary[]>("/api/v1/vehicle-trash"),
  // Substitui o DELETE direto no Traccar — grava o retrato e só depois
  // exclui de verdade lá. `traccarDeviceId` é o id numérico do device
  // (Vehicle.id do frontend, sempre string — converter antes de chamar).
  moveToTrash: (traccarDeviceId: number) =>
    gpsDrivePost<DeletedVehicleSummary>("/api/v1/vehicle-trash", { traccarDeviceId }),
  restore: (id: string) =>
    gpsDrivePost<DeletedVehicleSummary>(`/api/v1/vehicle-trash/${id}/restore`, {}),
};
